module.exports = __webpack_public_path__ + "static/media/CommuniHelp-Samples-StyleGuide.86f8a8b2.pdf";